import { useEffect } from 'react'
import { trackExperimentViewed } from '@mc/track-event'
import { EXPERIMENT_FLAG } from '../constants'

export const useTrackPen7387Experiment = () => {
  useEffect(() => {
    trackExperimentViewed(EXPERIMENT_FLAG)
  }, [])
}
